import { createContext, useContext, useState } from "react";
import { LANGUAGES } from "@/lib/languages";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("mp-lang");
    return LANGUAGES.find((l) => l.code === saved) || LANGUAGES[0];
  });

  const change = (code) => {
    const l = LANGUAGES.find((x) => x.code === code);
    if (l) {
      setLang(l);
      localStorage.setItem("mp-lang", code);
      window.speechSynthesis?.cancel();
    }
  };

  return <LanguageContext.Provider value={{ lang, change }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
